module.exports = __webpack_public_path__ + "static/media/HAYDIROKET-NO_JUSTICE_NO_PEACE.b97ec146.JPG";